import './modalreceipt.scss';

import { FunctionComponent } from "react";
import { useAppSelector } from '../../../../features';
import { getReceiptData } from '../../../../store/ReceiptSlice';
import { Amount } from '../../amount/amount';
import { exchangeRateTransformer, formatDatePtBr } from '../../../../utils/textFormatter';
import { QRCodeSVG } from 'qrcode.react';
import { Transactionlabel } from '../../../../types/transactions';

export const ChargeReceipt: FunctionComponent = () => {
    
    const receiptInfo   : any               = useAppSelector(getReceiptData);

    return (
        <div className="modal-body">
            <h1>
                    Recibo de Pagamento<br/>
                    <small>#{receiptInfo?.data?.charge?.id}</small>
                    <div className="label label-exchange-method">
                        {exchangeRateTransformer(receiptInfo?.data?.charge?.type)}
                    </div>
            </h1>

            <ul>
                <li>
                    <span>Nome</span>
                    <span className="small">{receiptInfo?.data?.charge?.payer_name || "- - -"}</span>
                </li>
                <li>
                    <span>Pagador</span>
                    <span className="small">{receiptInfo?.data?.charge?.payer || "- - -"}</span>
                </li>
                <li>
                    <span>Valor</span>
                    <span><Amount value={receiptInfo?.data?.charge?.amount || 0} format={false} isReceipt = {true}/></span>
                </li>
                <li>
                    <span>Preço Esperado</span>
                    <span><Amount value={receiptInfo?.data?.charge?.price} format={false} currency={receiptInfo?.data?.charge?.payer_currency.replace('fiat','')}  isReceipt = {true}/></span>
                </li>
                <li>
                    <span>Moeda Alvo</span>
                    <span className={`label label-${receiptInfo?.data?.charge?.payee_currency}`}>
                        {receiptInfo?.data?.charge?.payee_currency}
                    </span>
                </li>
                <li>
                    <span>Data</span>
                    <span className="small">{formatDatePtBr(receiptInfo?.data?.charge?.updated_at)}</span>
                </li>
                <li>
                    <span>Status</span>
                    <span className="label">{Transactionlabel(receiptInfo?.data?.charge?.status, true)}</span>
                </li>
            </ul>
            {receiptInfo?.data?.receipt?.id && (
                <>
                    <h2>
                        Recibo de Troca
                        <small># {receiptInfo?.data?.receipt?.id}</small>
                    </h2>
                    <ul>
                        <li>
                            <span>Moeda</span>
                            <span className={`label label-${receiptInfo?.data?.receipt?.currency}`}>
                                {receiptInfo?.data?.receipt?.currency}
                            </span>
                        </li>
                        <li>
                            <span>Preço Realizado</span>
                            <span>
                                <Amount value={receiptInfo?.data?.receipt?.price || 0} format={false} mini={false} currency={receiptInfo?.data?.receipt?.price_currency.replace('fiat','')} isReceipt = {true}/>
                            </span>
                        </li>
                        <li>
                            <span>Total</span>
                            <span>
                                <Amount value={receiptInfo?.data?.receipt?.amount || 0} format={false} currency={receiptInfo?.data?.receipt?.currency} isReceipt = {true}/>
                            </span>
                        </li>
                        <li>
                            <span>Status</span>
                            <span className="small label waiting">{Transactionlabel(receiptInfo?.data?.receipt?.status)}</span>
                        </li>
                        <li>
                            <span>Data</span>
                            <span className="small">{formatDatePtBr(receiptInfo?.data?.receipt?.updated_at)}</span>
                        </li>
                    </ul>
                </>
            )}
            <div className="qrcode">
                <QRCodeSVG value={"mailto:support@trkbit.co"} />
            </div>
        </div>
    )
}